import {version} from './modules/version';

document.addEventListener('DOMContentLoaded',e=>{
  const msg = document.createElement('div');
  msg.innerHTML = `</br>cs1-forest-demo ${version.version}`;
  document.body.appendChild(msg);
});

 